<template>
    <div>
        <span v-if="showLabel">{{field.label}}:</span>
        {{getFieldValue}}
    </div>
</template>

<script>
  export default {
    name: 'LightSwitch',
    props: {
      item: {
        type: Object
      },
      field: {
        type: Object,
        required: true
      },
      showLabel: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      getFieldValue () {
        if (this.item === null) {
          return ''
        }

        return this.item[this.field.handle].value === false ? 'Nein' : 'Ja'
      }
    }
  }
</script>

<style scoped>

</style>